import { HubFeature } from '@ats/api/cm';
import { LocDefs } from '@cm/core/localization';

export type SpNavigationHomeLocs =
	| 'SpNavigationHomeRoot'
	| 'SpNavigationHomeDashboard'
	| 'SpNavigationHomeProfile'
	| 'SpNavigationHomeProfileEmailHistory'
	| 'SpNavigationHomeProfileInformation';

export const spNavigationHomeLocs: LocDefs<SpNavigationHomeLocs> = {
	SpNavigationHomeRoot: {
		defaultValue: 'Home',
		description: 'Navigation menu group heading for Home',
		displayPath: 'Home|Navigation Heading',
		displayType: 'Label',
		feature: HubFeature.Core,
		portal: 'SP',
		legacyName: '/home',
	},
	SpNavigationHomeDashboard: {
		defaultValue: 'Dashboard',
		description: 'Navigation menu listing for Dashboard (Home)',
		displayPath: 'Home|Dashboard|Navigation Listing',
		displayType: 'Label',
		feature: HubFeature.Core,
		portal: 'SP',
		legacyName: '/home/dashboard',
	},
	SpNavigationHomeProfile: {
		defaultValue: 'Profile',
		description: 'Navigation menu listing for Profile (Home)',
		displayPath: 'Home|Profile|Navigation Listing',
		displayType: 'Label',
		feature: HubFeature.Core,
		portal: 'SP',
		legacyName: '/home/profile',
	},
	SpNavigationHomeProfileEmailHistory: {
		defaultValue: 'Email History',
		description: 'Navigation menu listing for Email History (Profile)',
		displayPath: 'Home|Profile|Email History|Navigation Listing',
		displayType: 'Label',
		feature: HubFeature.Core,
		portal: 'SP',
		legacyName: '/home/profile/email-history',
	},
	SpNavigationHomeProfileInformation: {
		defaultValue: 'My Information',
		description: 'Navigation menu listing for My Information (Profile)',
		displayPath: 'Home|Profile|Information|Navigation Listing',
		displayType: 'Label',
		feature: HubFeature.Core,
		portal: 'SP',
		legacyName: '/home/profile/information',
	},
};

export const spNavigationHomeLocMap: Record<string, SpNavigationHomeLocs> = {
	'/home': 'SpNavigationHomeRoot',
	'/home/dashboard': 'SpNavigationHomeDashboard',
	'/home/profile': 'SpNavigationHomeProfile',
	'/home/profile/email-history': 'SpNavigationHomeProfileEmailHistory',
	'/home/profile/information': 'SpNavigationHomeProfileInformation',
};
